import { IRoute } from "routes/IRoute";
import { IMenuConfiguration } from "Dashboard/domain/IMenuConfiguration";
import { LocalStorage } from "utils/local-storage";
import { FullUser } from "authentication/domain/FullUser";
import { IMenuItem } from "Dashboard/domain/IMenuItem";

export function isLoggedIn() {
  return !!LocalStorage.getItem("authenticatedUser");
}

export function getAllowedRoutes(user: FullUser, routes: IRoute[]): IRoute[] {
  return routes.filter(({ module }) => {
    if (!module) return true;
    else return isModuleAllowed(module, user.allAllowedModules);
  });
}

export function getAllowedMenu(
  user: FullUser,
  menuConfig: IMenuConfiguration
): IMenuConfiguration {
  let menu: IMenuConfiguration = {
    group1: menuConfig.group1.map<IMenuItem>((menuItem) => {
      if (!menuItem.module) menuItem.disabled = false;
      else
        menuItem.disabled = !isModuleAllowed(menuItem.module, user.allAllowedModules);
      return menuItem;
    }),
    group2: menuConfig.group2.map<IMenuItem>((menuItem) => {
      if (!menuItem.module) menuItem.disabled = false;
      else
        menuItem.disabled = !isModuleAllowed(menuItem.module, user.allAllowedModules);
      return menuItem;
    }),
    group3: menuConfig.group3.map<IMenuItem>((menuItem) => {
      if (!menuItem.module) menuItem.disabled = false;
      else
        menuItem.disabled = !isModuleAllowed(menuItem.module, user.allAllowedModules);
      return menuItem;
    }),
    group4: menuConfig.group4.map<IMenuItem>((menuItem) => {
      if (!menuItem.module) menuItem.disabled = false;
      else
        menuItem.disabled = !isModuleAllowed(menuItem.module, user.allAllowedModules);
      return menuItem;
    }),
    group5: menuConfig.group5.map<IMenuItem>((menuItem) => {
      if (!menuItem.module) menuItem.disabled = false;
      else menuItem.disabled = !isModuleAllowed(menuItem.module, user.allAllowedModules)
        || user.employee === undefined || user.employee === null;
      return menuItem;
    }),
  };
  return menu;
}

function isModuleAllowed(modulePrefix: string, allAllowedModules: string[]): boolean {
  for (const allowedModuleIndex in allAllowedModules) {
    const allowedModule = allAllowedModules[allowedModuleIndex];
    if (allowedModule.startsWith(modulePrefix)) {
      return true;
    }
  }
  return false;
}
